<template>
  <div class="my-10 flex col items-center">
    <h1>{{ error.statusCode }}</h1>
    <p class="lead">
      {{ $t('error_page.wrong') }}
    </p>
    <nuxt-link to="/">
      {{ $t('error_page.home') }}
    </nuxt-link>
  </div>
  <TheFooter />
</template>

<script setup lang="ts">
import type { NuxtError } from '#app';

defineProps<{
  error: NuxtError;
}>();
</script>